import React from "react";
import { Link } from "react-router-dom";

const CheckActions = props => {
  if (props.actions) return <div className="dropdown">
    <button className="btn btn-sm btn-dropdown-toggle no-caret" data-toggle="dropdown"><i className="sky-icon-menu" style={{ "font-size": "20px" }}></i></button>
    <ul className="dropdown-menu dropdown-right minw-0 nowrap">
      {props.actions.map(action => {
        action['action_key'] = props.action_key;
        return Action(action.location, action.onClick, action.label, props[props.action_key]);
      })}
    </ul>
  </div>
  else return null
}

const Action = (
  location = "",
  onClick = () => null,
  label = "",
  action_key = ""
) =>
  <li><Link to={location} onClick={onClick(action_key)}>{label}</Link></li>


function NestedItem({ field, row }) {
  if (Array.isArray(field) && row[field[0]]) {
    return <strong>{row[field[0]][field[1]]}</strong>
  } else {
    return <strong>{row[field]}</strong>
  }
}


export const TableDashboardRow = props => {
  return <div className="list-item-sm p-0">
    <div className="p-1">
      {/* <a href="number-dashboard.php"></a> */}
      <small><p>
        {props.keys.map((key, index) => {
          if (key === props.main_key) {
            return <h3 className="mb-0">{props.row[key]}</h3>
          } else {
            if (props.keys.length - 1 > index) return <span className="d-inline-block">{`${props.labels[index]}: `} <strong><NestedItem field={key} row={props.row} />, </strong></span>
            else return <span className="d-inline-block">{props.labels[index]}: <NestedItem field={key} row={props.row} /></span>
          }
        }
        )}
      </p>
      </small>
    </div>
    <div className="py-1 pr-h ml-auto">
      <CheckActions></CheckActions>
    </div>
  </div>
}
